import { type ApolloError } from '@apollo/react-hooks';
import { type OFFER_STATUS } from '../../../Assessment/GSAssessment/components/GSToDoList/constants';
import type { PROGRAMME_TYPE } from '../../components';
import { type STUDY_MODE } from '../ApplicationForm';
import type { FileData } from '../../../../components';

export enum VisaApplicationStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}

export enum MeetingConditionStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  MODIFICATION_REQUIRED = 'MODIFICATION_REQUIRED',
}

export enum QualificationCheckStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  MODIFICATION_REQUIRED = 'MODIFICATION',
}

export type VisaApplicationResult = {
  refNo?: string;
  status?: VisaApplicationStatus;
  applicationDate?: Date;
  url?: string;
  issuedDate?: Date;
  remarks?: string | string[];
};

export type MeetingConditionResult = {
  applicationDate?: Date;
  updatedDate?: Date;
  status?: MeetingConditionStatus;
  remarks?: string | string[];
};

export type QualificationCheckResult = {
  applicationDate?: Date;
  updatedDate?: Date;
  status?: QualificationCheckStatus;
  remarks?: string | string[];
};

export type ApplicationDetail = {
  applicationNo: string;
  applicationName: {
    givenName: string;
    surname: string;
    chineseName: string;
  };
  supervisor: {
    type: string;
    givenName: string;
    surname: string;
  };
  programme: string;
  polyuStudyPeriod?: {
    from: string;
    to: string;
  };
};

export type GetApplicationDetail = {
  applicationDetail: ApplicationDetail;
  loading: boolean;
  error: ApolloError | undefined;
};

export type OfferDetails = {
  applicationId: string;
  applicationNo: string;
  applicantName: string;
  offeredToSemester: string;
  applicantChineseName: string;
  applicantNationality: string;
  refNo: string;
  offerDate: Date;
  isFirmOffer: boolean;
  isLocal: boolean;
  scheduledRegistrationDate: Date;
  entryYear: string;
  department: string;
  programme: string;
  programmeType: PROGRAMME_TYPE;
  programmeCode: string;
  programmeSubcode: string;
  studyMode: STUDY_MODE;
  normalPeriodOfStudy: string | number;
  creditRequirement: string | number;
  reportingDutyDate: string;
  commencementDate: string;
  fundingLetter: FileData;
  supervisor: string;
  researchArea: string;
  acceptDeadline: Date;
  conditions: [
    {
      item: string;
      detail: string;
      title: string;
      file: {
        id: string;
        link: string;
        name: string;
      };
      remark: string;
      passed: boolean;
    },
  ];
  conditionFulfilled: boolean;
  conditionFulfillingDeadline: string;
  status: OFFER_STATUS;
};

export type GetOfferDetails = {
  offerDetails: OfferDetails;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};
